import {useState} from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const SparkMD5 = require('spark-md5');

interface UseChecksumReturn {
  checksum: string | null;
  error: Error | null;
  computeChecksum: (file: File) => void;
}

export const useChecksum = (): UseChecksumReturn => {
  const [checksum, setChecksum] = useState<string | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const computeChecksum = async (file: File) => {
    setError(null);
    try {
      const reader = new FileReader();
      reader.onload = () => {
        const binaryStr = reader.result as string;
        const md5Hash = SparkMD5.hashBinary(binaryStr);

        const byteArray = md5Hash.match(/.{1,2}/g)?.map((byte: string) => String.fromCharCode(parseInt(byte, 16)));

        if (!byteArray) {
          setError(new Error('Failed to compute checksum'));
          return;
        }

        const base64Checksum = btoa(byteArray.join(''));
        setChecksum(base64Checksum);
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      setError(new Error('Error computing checksum'));
    }
  };

  return {
    checksum,
    error,
    computeChecksum,
  };
};

export default useChecksum;
